import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class BasicInformationDataShareService {

  constructor() { }
  Basicinfodata: any;
  diffDays: any;
  createdDate: any;
  modifiedDate: any;
  isCurrentAPfainalise: any = null
  currentAPSubmitStatus: any = null
  currentAPSubmitDate: any = null
  CharityFinancialSubForm: FormGroup;
  CreateFinancialSubForm() {
    debugger
    this.CharityFinancialSubForm = new FormGroup({
      financialPeriodsID: new FormControl(null),
      last_AP_Start_Date: new FormControl(null),
      isFirst_AP: new FormControl('yes'),
      last_AP_End_Date: new FormControl(null),
      current_AP_Start_Date: new FormControl(null, Validators.required),
      current_AP_End_Date: new FormControl(null, Validators.required),
      financial_Year: new FormControl({ value: null, disabled: true }),
      accounting_Method: new FormControl(null, Validators.required),
      accounting_Template: new FormControl(null),
      report_Type: new FormControl('Independent Examiner'),
      fund_Tracking: new FormControl(true),
      period_Duration: new FormControl(null),
      account_Type: new FormControl('Original'),
      report_Title: new FormControl("Unaudited Trustees' Report and Financial Statements", Validators.required),
      audited_Type: new FormControl('CharitesAct2011'),
      isAudit_Exemption: new FormControl(false),
      is_Trading: new FormControl("no"),
      isDormant: new FormControl(false)
    })
    //this.CharityFinancialSubForm.controls['last_AP_Start_Date'].disable()
    // this.CharityFinancialSubForm.controls['last_AP_End_Date'].disable()
  }
}
